// Path: src/components/aols/aeo/OLShealth/OLSHealthMonitor.tsx
// feat: Created new OLS Health Monitor component.
// Displays a 12-hour timeline from 6 AM to 6 PM, highlighting the current hour.
// Includes a notes section for user interaction.
// 06/08/25 11:12 AM +07


import React, { useState, useEffect } from 'react'; // FIX: Added useState and useEffect to the import
import styled from 'styled-components';
import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

const MonitorWrapper = styled.div`
  background: #1c1c1e;
  padding: 20px;
  border-radius: 12px;
  margin-top: 30px;
  border: 1px solid #333;
`;

const TimeBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: #2c2c2e;
  border-radius: 8px;
  padding: 10px;
  margin-top: 20px;
`;

const HourBlock = styled.div<{ $isActive: boolean }>`
  flex: 1;
  text-align: center;
  padding: 10px 5px;
  color: #8e8e93;
  border-right: 1px solid #444;
  position: relative;
  transition: all 0.3s ease;

  &:last-child {
    border-right: none;
  }

  ${(props) =>
    props.$isActive &&
    `
    background-color: #ffaa00;
    color: #000;
    font-weight: bold;
    border-radius: 6px;
    box-shadow: 0 0 15px rgba(255, 170, 0, 0.7);
  `}
`;

const NotesArea = styled.div`
  margin-top: 15px;
  text-align: center;
  color: #8e8e93;
  font-style: italic;
  font-size: 14px;
`;

const OLSHealthMonitor: React.FC = () => {
  const [currentHour, setCurrentHour] = useState(new Date().getHours());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentHour(new Date().getHours());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  const hours = Array.from({ length: 13 }, (_, i) => i + 6); // 6 AM to 6 PM (18:00)

  return (
    <MonitorWrapper>
      <Title level={4} style={{ color: '#ffcc00', textAlign: 'center' }}>
        OLS Health Monitor
      </Title>
      <Paragraph style={{ color: '#fff', textAlign: 'center' }}>
        Track your daily progress from Sunrise (6 AM) to Sunset (6 PM).
      </Paragraph>
      <TimeBarContainer>
        {hours.map((hour) => (
          <HourBlock key={hour} $isActive={hour === currentHour}>
            {hour % 12 === 0 ? 12 : hour % 12}{' '}{hour < 12 ? 'AM' : 'PM'}
          </HourBlock>
        ))}
      </TimeBarContainer>
      <NotesArea>Space for notes between hours</NotesArea>
    </MonitorWrapper>
  );
};

export default OLSHealthMonitor;